(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    if (!root || root.dataset.mjrCatalogCarouselBound === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-mjr-catalog-editorial-slide]'));
    if (slides.length < 2) return;

    root.dataset.mjrCatalogCarouselBound = 'true';
    let activeIndex = 0;
    let timer = null;

    const showNext = () => {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add('is-active');
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!reduceMotion.matches && !document.hidden) {
        timer = window.setInterval(showNext, 6800);
      }
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) start();
      else stop();
    }, { threshold: 0.15 });

    observer.observe(root);
    document.addEventListener('visibilitychange', start);
    reduceMotion.addEventListener?.('change', start);
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-mjr-catalog-editorial-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
